import { useTranslation } from 'react-i18next';
import { Descriptions, Typography } from 'antd';
import { ProfileInfoResponse } from 'all-in-one-shared-api';
import { DependentAvatar } from './DependentAvatar';
import { DependentRow } from './DependentRow';
import React from 'react';

interface DependentGroupProps {
  title: string;
  dependents: Array<ProfileInfoResponse['familyMembers'][number]>;
  isSpouse: boolean;
}

export const DependentGroup = ({ title, dependents, isSpouse }: DependentGroupProps): JSX.Element => {
  const { t } = useTranslation();

  if (dependents.length === 0) {
    return <></>;
  }

  return (
    <>
      <Typography.Title level={4} style={{ marginTop: 32, marginBottom: 16 }}>
        {title}
      </Typography.Title>
      <Descriptions bordered column={1} style={{ backgroundColor: 'white' }}>
        {dependents.map((dependent) => {
          const name = `${dependent.firstName} ${dependent.lastName}`;
          const memberType = dependent.memberType;
          const submitAndViewValue = dependent?.submitClaimForAll?.toString() === 'true';
          const shortfallRight = dependent?.payShortfallForAll?.toString() === 'true';
          const registerStatus = dependent?.registerStatus?.toString() === 'true';
          const dependentData = { name, memberType, submitAndViewValue, shortfallRight, registerStatus };

          return (
            <React.Fragment key={`${name}-${memberType}`}>
              <Descriptions.Item label={t('profile.name')}>
                <DependentRow isSpouse={isSpouse} dependentData={dependentData} />
              </Descriptions.Item>
              <Descriptions.Item label={t('profile.avatar')}>
                <DependentAvatar isSpouse={isSpouse} dependentData={dependentData} />
              </Descriptions.Item>
            </React.Fragment>
          );
        })}
      </Descriptions>
    </>
  );
};
